import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import DropdownMenu from './DropdownMenu';
import includes from 'lodash/includes';

const styles = theme => ({
  root: {
    width: '100%',
  },
  navbarLink: {
    color: '#4A4A4A',
    textDecoration: 'none',
    padding: '0 0.3rem',
    whiteSpace: 'nowrap',
    '&:hover': {
      color: '#4A4A4A',
      textDecoration: 'none',
    },
    alignSelf: 'center',
  },
  navbarItem: {
    borderBottom: '2px solid #fff',
    display: 'flex',
    padding: '0 .5rem',
    [theme.breakpoints.up('xl')]: {
      padding: '0 1rem'
    },
    '&:hover': {
        borderBottom: `2px ${theme.palette.primary.main} solid`,
        borderRadius: 1,
    }
  },
  navbarItemActive: {
    borderBottom: `2px ${theme.palette.primary.main} solid`,
    borderRadius: 1,
  },
});

class NavbarItem extends React.Component {
  state = {
    anchorEl: null,
    isNavigationHead: false
  };

  handleMenuOpen = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  handleCurrentNavigationLabel = () => {
    let path = `${decodeURIComponent(window.location.pathname)}/`;
    const {link} = this.props;
    this.setState({isNavigationHead: includes(path, link) });

  };
  componentDidMount(){
    this.handleCurrentNavigationLabel();
  }

  render() {
    const { classes, label, link, menuItems } = this.props;

    return (
        <li className={`${classes.navbarItem} ${this.state.isNavigationHead ? classes.navbarItemActive : null}`} onMouseOver={menuItems && this.handleMenuOpen} onMouseLeave={menuItems && this.handleMenuClose}>
            <a href={link} className={`${classes.navbarLink} navbar-item`}>{label}</a>
            {menuItems && (
                <DropdownMenu anchorEl={this.state.anchorEl} items={menuItems}/>
            )}
        </li>
    )
  }
}

NavbarItem.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string,
  menuItems: PropTypes.array,
};

export default withStyles(styles)(NavbarItem);
